import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

export const MuiCheckbox = (props: any) => {
    const { id, name, label, value, onChange, className, sx, disabled, margin, error } =
        props;

    const convertToDefEventPara = (id: any, name: any, value: boolean) => ({
        target: {
            id,
            name,
            value,
        },
    });

    return (
        <FormControl>
            <FormControlLabel
                style={{ margin: margin }}
                className={className}
                required={error} //show required
                rowSelection="multiple"
                control={
                    <Checkbox
                        sx={sx}
                        id={id}
                        name={name}
                        color="primary"
                        checked={value}
                        onChange={(e) =>
                            onChange(convertToDefEventPara(id, name, e.target.checked))
                        }
                        disabled={disabled}
                    />
                }
                label={label}
                {...(error && { error: true, helperText: error })}
            />
        </FormControl>
    );
};
